import { axiosInstance } from '../utils/axios';

export const getChannelActivity = (
  { orgId, streamId, channelId, offset = 0, count = 10 },
  extraData,
) =>
  axiosInstance(
    `/${orgId}/${streamId}/${channelId}/activity?offset=${offset}&count=${count}`,
    extraData,
  );
